(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
// Section 1: swipe indicator — sync the custom scrollbar thumb to the carousel scroll position.
function s1InitRecScrollbar(root) {
  if (!root) return;
  var bar = root.querySelector('.s1-carousel-scrollbar');
  var thumb = root.querySelector('.s1-carousel-scrollbar__thumb');
  if (!bar || !thumb) return;
  var cands = root.querySelectorAll('.product-list, .collection-listing, .related-collection');
  var scroller = null;
  for (var i = 0; i < cands.length; i++) {
    if (cands[i].scrollWidth > cands[i].clientWidth + 2) { scroller = cands[i]; break; }
  }
  if (!scroller) scroller = root.querySelector('.product-list');
  if (!scroller) { bar.style.display = 'none'; return; }
  function update() {
    var sw = scroller.scrollWidth, cw = scroller.clientWidth;
    if (sw <= cw + 2) { bar.style.display = 'none'; return; } // fits on screen, no scroll needed
    bar.style.display = '';
    var thumbW = Math.max((cw / sw) * 100, 12);
    thumb.style.width = thumbW + '%';
    var pos = (sw - cw) > 0 ? (scroller.scrollLeft / (sw - cw)) : 0;
    thumb.style.left = (pos * (100 - thumbW)) + '%';
  }
  scroller.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
  setTimeout(update, 300);
  setTimeout(update, 900);
}
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
      s1InitRecScrollbar(productRecommendationsSection);
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-cards-swipeable"] && !Shopify.designMode) return;
  try {
    
// Section 1: swipe indicator — sync the custom scrollbar thumb to the promo-cards track scroll
// (matches the "You may also like" indicator).
(function () {
  function initPromoScrollbar() {
    var roots = document.querySelectorAll('.promo-cards');
    for (var r = 0; r < roots.length; r++) {
      (function (root) {
        var scroller = root.querySelector('.promo-cards__track');
        var bar = root.querySelector('.s1-carousel-scrollbar');
        var thumb = root.querySelector('.s1-carousel-scrollbar__thumb');
        if (!scroller || !bar || !thumb || bar.dataset.s1Bound) return;
        bar.dataset.s1Bound = '1';
        function update() {
          var sw = scroller.scrollWidth, cw = scroller.clientWidth;
          if (sw <= cw + 2) { bar.style.display = 'none'; return; }
          bar.style.display = '';
          var thumbW = Math.max((cw / sw) * 100, 12);
          thumb.style.width = thumbW + '%';
          var pos = (sw - cw) > 0 ? (scroller.scrollLeft / (sw - cw)) : 0;
          thumb.style.left = (pos * (100 - thumbW)) + '%';
        }
        scroller.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
        setTimeout(update, 300);
        setTimeout(update, 900);
      })(roots[r]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoScrollbar);
  } else {
    initPromoScrollbar();
  }
  document.addEventListener('shopify:section:load', initPromoScrollbar);
})();

  } catch(e) { console.error(e); }
})();
})();
